// custom typefaces — weights used across the site and the store chrome (200/300/600/700/800)
// normalize CSS across browsers
require ("./src/normalize.css");
// custom CSS styles
require ("./src/bootstrap-custom.css");
require ("./src/style.css");
// header/footer parity with the Magento store — must load after bootstrap
require ("./src/store-chrome.css");

exports.shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition,
  }) => {
    const currentPosition = getSavedScrollPosition(location);
    setTimeout(() => { window.scrollTo(...(currentPosition || [0, 0])); }, 100);
  
    return false;
  };
  